import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 196 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1F2329",
      "fill-rule": "evenodd",
      d: "M71.04 18C71.78 7.97 83.56 0 98 0c14.44 0 26.22 7.97 26.96 18H140v10h18a38 38 0 0 1 38 38v136a38 38 0 0 1-38 38h-54.17a77.77 77.77 0 0 0 23.59-18H158a20 20 0 0 0 20-20V66a20 20 0 0 0-20-20h-18v11H57V46H38a20 20 0 0 0-20 20v46.58a77.78 77.78 0 0 0-18 23.59V66a38 38 0 0 1 38-38h19V18h14.04ZM104 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#1F2329",
      "fill-rule": "evenodd",
      d: "M118.64 121.36a69.5 69.5 0 1 0-98.28 98.28 69.5 69.5 0 0 0 98.28-98.28Zm-36.5 49.14h25.27a6.32 6.32 0 0 1 6.22 5.18l.1 1.14v25.27l-.1 1.14a6.32 6.32 0 0 1-12.44 0l-.1-1.14.01-7.99-1.51 1.9a39.45 39.45 0 0 1-48.38 9.52 39.38 39.38 0 0 1-14.11-12.4 6.32 6.32 0 1 1 10.36-7.25 26.86 26.86 0 0 0 45.67-2.73h-11l-1.13-.1a6.31 6.31 0 0 1 0-12.44l1.14-.1Zm-42.77-25.58a39.52 39.52 0 0 1 48.38-9.4 39.37 39.37 0 0 1 14.12 12.49 6.32 6.32 0 0 1-10.36 7.2 26.87 26.87 0 0 0-45.74 2.65h11.1l1.13.1a6.31 6.31 0 0 1 0 12.44l-1.14.1H31.58l-1.14-.1a6.32 6.32 0 0 1-5.08-5.08l-.1-1.14v-25.27l.1-1.14a6.32 6.32 0 0 1 12.44 0l.1 1.14-.03 7.9 1.5-1.89Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }